<template>
  <tr class="row-tr">
    <td class="bet-type-col sticky-col">
      {{ row.betType }}
    </td>
    <td v-for="sectionKey in SECTION_ORDER" :key="sectionKey" class="cell-col">
      <div :class="getGridClass(sectionKey)">
        <EditCell
          v-for="field in SECTIONS_FIELDS[sectionKey]"
          :key="sectionKey + '-' + field"
          :value="getVal(sectionKey, field)"
          :type="field === 'accept' ? 'select' : 'input'"
          :options="field === 'accept' ? ['Auto', 'Manual'] : []"
          placeholder="0"
          @changeInput="(val) => emitCellChange(sectionKey, field, val)"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { objectProp } from "@/helpers/props";
import EditCell from "./EditCell.vue";

export default {
  name: "SpreadsheetRow",
  components: { EditCell },
  props: {
    row: objectProp(),
    config: objectProp(),
  },
  data() {
    const SECTIONS_FIELDS = {
      metroThoroughbreds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      nonMetroThoroughbreds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      internationalThoroughbreds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      metroGreyhounds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      nonMetroGreyhounds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      internationalGreyhounds: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      metroHarness: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      nonMetroHarness: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
      internationalHarness: [
        "cashMaxStake",
        "bonusMaxStake",
        "maxCashLia",
        "maxBonusLia",
        "cashMaxStakeNoFixedOdds",
        "bonusMaxStakeNoFixedOdds",
        "maxCashLiaNoFixedOdds",
        "maxBonusLiaNoFixedOdds",
        "accept",
      ],
    };

    const SECTION_ORDER = [
      "metroThoroughbreds",
      "nonMetroThoroughbreds",
      "internationalThoroughbreds",
      "metroGreyhounds",
      "nonMetroGreyhounds",
      "internationalGreyhounds",
      "metroHarness",
      "nonMetroHarness",
      "internationalHarness",
    ];

    return {
      SECTIONS_FIELDS,
      SECTION_ORDER,
    };
  },
  methods: {
    getVal(section, field) {
      if (!this.config) return "";
      const s = this.config[section];
      if (!s) return "";
      return s[field] !== undefined && s[field] !== null ? `${s[field]}` : "";
    },
    emitCellChange(section, field, value) {
      this.$emit("onCellChange", this.row.key, section, field, value);
    },
    getGridClass(sectionKey) {
      const len = this.SECTIONS_FIELDS[sectionKey]
        ? this.SECTIONS_FIELDS[sectionKey].length
        : 7;
      return len === 9 ? "grid-9" : "grid-7";
    },
  },
};
</script>

<style scoped>
.row-tr {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.bet-type-col {
  padding: 12px 16px;
  font-weight: 600;
  background: #f8fafc;
  font-size: 12px;
  position: sticky;
  left: 0;
  z-index: 10;
}
.grid-9 {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 16px;
}
.grid-7 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 16px;
}
.cell-col {
  padding: 12px;
}
</style>
